import styled from 'styled-components';
import Button from 'antd/lib/button';

export const ToggleExportSettingsButtonContainer = styled(Button)`
  position: absolute;
  right: 50px;
  top: 10px;
`;
